import { useIsHelpVisible, useToggleHelpVisibility } from '@map/state/help';
import useHelpKeywords from '@shared/hooks/help/useHelpKeywords';
import { useChatUnreadMessages, zendeskEnabled } from '@shared/lib/zendesk/hooks';
import Button from '@ui/Button';
import HelpIcon from '@ui/Icon/library/HelpIcon';
import { DEV } from 'esm-env';
import { MouseEventHandler, useCallback } from 'react';
import UnreadChatBadge from '../UnreadChatBadge';

type Props = {
  className?: string;
  inverse?: boolean;
  hideWhenInactive?: boolean;
};
const HelpButton = ({ hideWhenInactive, className, inverse }: Props) => {
  const isOpen = useIsHelpVisible();
  const helpKeywords = useHelpKeywords();
  const unreadMessageCount = useChatUnreadMessages();
  const toggleHelpVisibility = useToggleHelpVisibility();

  const handleClick: MouseEventHandler = useCallback(
    (e) => {
      if (e.shiftKey && DEV) {
        // eslint-disable-next-line no-alert
        alert(helpKeywords.join(','));
        return;
      }
      toggleHelpVisibility(!isOpen);
    },
    [helpKeywords, isOpen, toggleHelpVisibility],
  );

  return (
    <Button
      className={className}
      variant="tertiary"
      onClick={handleClick}
      inverse={inverse}
      style={
        !zendeskEnabled || (hideWhenInactive && unreadMessageCount === 0) ? { display: 'none' } : {}
      }
      ariaLabelIntlKey="help.title"
      icon={true}
    >
      <UnreadChatBadge>
        <HelpIcon />
      </UnreadChatBadge>
    </Button>
  );
};

export default HelpButton;
